
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import TabSalesButton from "../../components/buttons/TabSalesButton";
import { refreshTab } from "../../features/tabs/tabSlice";
import PartnerApi from "../../helpers/PartnerApi";
import { error as toastError } from "../../features/toast/toastSlice";

const EditButtonSales = ({ data, ...props }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onEditSalesClick = async () => {
    if (!data?.licenseNo) return;

    const licenseNo = data.licenseNo;
    const tabId = `licenseSalesList-${licenseNo}`;

    try {
      // PRE-FLIGHT: veri var mı?
      const list = await PartnerApi.getLicenseSalesList({ licenseNo });
      const hasData = Array.isArray(list) && list.length > 0;

      if (!hasData) {
        // liste boş → tab AÇILMAZ, sadece toast göster
        dispatch(
          toastError({
            title: "Error",
            message: `${t("No sales log data for license")} ${licenseNo}.`,
            delay: 6000,
          })
        );
        return;
      }

      // veri var → tabı aç
      dispatch(
        refreshTab({
          id: tabId,
          title: "Sales",
          component: "components/buttons/sales/LicenseSalesTableTab",
          tabIcon: "ConnectionIcon",
          componentProps: { licenseNo, tabId },
        })
      );
    } catch (err) {
      const msg =
        err?.response?.data?.error?.message ||
        err?.message ||
        t("Sales list fetch failed.");
      dispatch(
        toastError({
          title: "Error",
          message: msg,
          delay: 6000,
        })
      );
    }
  };

  return <TabSalesButton {...props} onClick={onEditSalesClick} />;
};

export default EditButtonSales;
